@if (header) {
<div class="mwp-table-header w-100 d-flex justify-content-center align-items-center">
  @if (translateHeader) {
  <div class="title d-inline-flex w-100 p-3">
    <mwp-text-translate [text]="header" [jsonKey]="header" />
    {{nameInHeader}}
  </div>
  }
  @if (!translateHeader) {
  <div class="title d-inline-flex w-100 p-3">
    {{header}}{{nameInHeader}}
  </div>
  }
</div>
}
<div class="mwp-table-body" [ngClass]="[ isModal ? 'is-modal' : '' , header ? 'px-3': 'no-header']">
  @if (isLoaded) {
  <form [formGroup]="form">
    <table mat-table [dataSource]="dataSource">
      <div [formArrayName]="arrayName">
        @for (tableColumn of tableColumns; track $index) {
        <ng-container matColumnDef="{{tableColumn.propertyId}}">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width' : (tableColumn.width) ? (tableColumn.width) : 'auto'}">
            @if (tableColumn.columnType === columnType.checkBoxSelectAll) {
            <div>
              <mat-checkbox [checked]="isSelectAll" (change)="selectAll($event, tableColumn)" />
            </div>
            }
            @if (tableColumn.columnType != columnType.checkBoxSelectAll && tableColumn.columnName !='' ) {
            <div>
              <mwp-text-translate [text]="tableColumn.columnName" [jsonKey]="tableColumn.columnName" />
            </div>
            }
          </th>
          <td mat-cell *matCellDef="let element; index as rowIndex" [formGroupName]="rowIndex">
            @if (displayElement(tableColumn, columnType.checkBoxSelectAll, element)) {
            <div>
              <mat-checkbox [formControlName]="tableColumn.propertyId" (change)="selectAllChange($event, tableColumn)">
                @if (tableColumn.dataTypeText) {
                <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
                }
              </mat-checkbox>
            </div>
            }
            @if (displayElement(tableColumn, columnType.checkBox, element)) {
            <div>
              <mat-checkbox [formControlName]="tableColumn.propertyId" [checked]="element[tableColumn.propertyId]" (change)="checkBoxChange($event, tableColumn, element)">
                @if (tableColumn.dataTypeText) {
                <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
                }
              </mat-checkbox>
            </div>
            }
            @if (displayElement(tableColumn, columnType.hyperLink, element)) {
            <div class="d-inline-flex">
              @if(findElementByColumnName(element, tableColumn.dataTypePropertyId, tableColumn.textType) != ""){
              <a (click)="openLink(element[tableColumn.propertyId], tableColumn.isNewTab, tableColumn.isEmit, element)">
                @if (tableColumn.svgPropertyId || tableColumn.svgCustomName) {
                  <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)"/>
                }
                <span>{{ findElementByColumnName(element, tableColumn.dataTypePropertyId, tableColumn.textType) }}</span>
              </a>
              }
            </div>
            }
            @if (displayElement(tableColumn, columnType.button, element)) {
            <div>
              <button (click)="selection(element, tableColumn)" [ngClass]="tableColumn.cssCustomClass ? tableColumn.cssCustomClass : 'mwp-button'">
                <mwp-text-translate [text]="tableColumn.dataTypeText" [jsonKey]="tableColumn.dataTypeText" />
              </button>
            </div>
            }
            @if (displayElement(tableColumn, columnType.slideToggle, element)) {
            <div>
              <mat-slide-toggle [class]="findSlideToggleCSS(element, tableColumn.dataTypeText)" [formControlName]="tableColumn.propertyId" (change)="slideToggleChange($event, tableColumn, element, rowIndex)">
                <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
              </mat-slide-toggle>
            </div>
            }
            @if (displayElement(tableColumn, columnType.buttonToggle, element)) {
            <div>
              <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [formControlName]="tableColumn.propertyId">
                @for (item of tableColumn.listArray; track item) {
                <mat-button-toggle [value]="item.value">
                  {{item.text}}
                </mat-button-toggle>
                }
              </mat-button-toggle-group>
            </div>
            }
            @if (displayElement(tableColumn, columnType.dropDown, element)) {
            <div>
              <mat-form-field appearance="outline">
                <mat-select [formControlName]="tableColumn.propertyId">
                  @for (item of tableColumn.listArray; track item) {
                  <mat-option [value]="item.value">
                    {{item.text}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
            @if (displayElement(tableColumn, columnType.input, element)) {
            <div class="pe-4">
              <mat-form-field appearance="outline">
                @if (!tableColumn.maskType) {
                <input matInput [formControlName]="tableColumn.propertyId">
                }
                @if (tableColumn.maskType) {
                <input matInput [formControlName]="tableColumn.propertyId" [mwpMask]="tableColumn.maskType" [mwpMaskForm]="getArrayFormGroup(rowIndex)" [mwpMaskFormControlName]="tableColumn.propertyId">
                }
              </mat-form-field>
            </div>
            }
            @if (displayElement(tableColumn, columnType.labelAndToolTip, element)) {
            <div>
              <div class="d-inline-flex align-items-center">
                @if (element[tableColumn.toolTip] && !tableColumn.toolTipDisplayEnd) {
                <div>
                  <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)" [SvgColor]="findSVGColor(tableColumn.toolTipCSS)" [ToolTipMessage]="element[tableColumn.toolTip]" [ToolTipClass]="tableColumn.toolTipCSS" />
                </div>
                }
                <div class="me-2">
                  <span>{{ findElementByColumnName(element, tableColumn.propertyId, tableColumn.textType) }}</span>
                </div>
                @if (element[tableColumn.toolTip] && tableColumn.toolTipDisplayEnd) {
                <div>
                  <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)" [SvgColor]="findSVGColor(tableColumn.toolTipCSS)" [ToolTipMessage]="element[tableColumn.toolTip]" [ToolTipClass]="tableColumn.toolTipCSS" />
                </div>
                }
              </div>
            </div>
            }
            @if (displayElement(tableColumn, columnType.label, element)) {
            <div>
              <span>{{ findElementByColumnName(element, tableColumn.propertyId, tableColumn.textType) }}</span>
            </div>
            }
            @if (displayElement(tableColumn, columnType.iconButton, element)) {
            <div class="selectable">
              @if (displayIconButton(element, tableColumn)) {
                <mwp-svg-icon [SvgMatType]="findSVGTypeByCustomName(tableColumn.svgCustomName)" (click)="selection(element, tableColumn)"/>
              }
            </div>
            }
          </td>
        </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="renderdColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: renderdColumns;" [ngClass]="[hasControls ? 'has-controls' : '']"></tr>
      </div>
    </table>
    @if (!dataSource || dataSource.data.length === 0) {
    <div class="d-flex justify-content-center w-100 table-no-data">
      <div>
        <mwp-text-translate text="No Data Found!" jsonKey="noDataFound" />
      </div>
    </div>
    }
  </form>
  }
</div>